// =============================================================================
// R2-FRONT — logique PURE de décision d'injection d'auth (sans dépendance).
// Séparée de authInterceptors.js (qui importe axios) pour être testable seule.
// =============================================================================

/**
 * Décide si on attache le Bearer à cette URL.
 * N'injecte QUE vers NOTRE backend /api :
 *   - same-origin que la page, OU
 *   - l'origine configurée REACT_APP_BACKEND_URL (apiOrigin) — couvre les
 *     sous-domaines (page dal.omnihub-ia.fr → API omnihub-ia.fr).
 * Un vrai tiers (Zoho, externe) n'est NI l'un NI l'autre → false.
 * Paramètres pageOrigin/apiBase injectables pour les tests (défauts runtime).
 */
export function shouldAttachAuth(
  rawUrl,
  { pageOrigin = (typeof window !== "undefined" ? window.location.origin : ""),
    apiBase = process.env.REACT_APP_BACKEND_URL } = {}
) {
  try {
    const u = new URL(rawUrl, pageOrigin); // résout les URLs relatives sur la page
    const apiOrigin = apiBase ? new URL(apiBase, pageOrigin).origin : null;
    const isOurBackend = u.origin === pageOrigin || (apiOrigin && u.origin === apiOrigin);
    return isOurBackend && u.pathname.startsWith("/api");
  } catch {
    return false; // URL non parsable → défaut sûr : on n'injecte pas
  }
}
